import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { SessionUserHashManagerService } from '../../_services/session-user-hash-manager/session-user-hash-manager.service';
import { takeUntil } from 'rxjs/operators';
import { TutorReportsHelperService } from '../../_helpers/tutor-reports-helper/tutor-reports-helper.service';
import { AuthenticationStateHelperService } from '../../_helpers/authentication-state-helper/authentication-state-helper.service';

@Component({
    selector: 'app-tuition-report',
    templateUrl: './tuition-report.component.html',
    styleUrls: ['./tuition-report.component.css'],
    standalone: false
})
export class TuitionReportComponent implements OnInit, OnDestroy {

  public placementId: number;
  public showTutorReports: boolean = false;

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public themeService: ThemeService,
    private featureHelperService: FeatureHelperService,
    private router: Router,
    private route: ActivatedRoute,
    private userHashManager: SessionUserHashManagerService,
    public tutorReportsHelperService: TutorReportsHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService
    ) { 
      this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe(params => {
        if (!params['id']) {
          this.router.navigate(['/login']);
        } else {
          this.userHashManager.checkUserForExternal();

          this.themeService.setActiveTheme('LEAP');

          let featureList = new Array<string>();
          featureList.push("TutorReportsView");

          let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

          if (!currentUserFeatures.filter(f => f.feature === "TutorReportsView")[0].enabled) {
            console.error("User does not have the required permissions to view the tutor reports screen");
            this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
            this.authenticationStateHelper.unauthorizedToken = true;
          }

          this.placementId = +params['id'];
         
          this.tutorReportsHelperService.setCommonDataBeforeNavigate(this.placementId);
          setTimeout(() => {
            this.showTutorReports = true;
          }, 100);
          
        }
      });
    }

  ngOnInit() {
    
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public backToSite(): void {
    this.router.navigate(['/']);
  }

}
